import $ from 'jquery';

let instance = null;

export default class ServerTime {
    constructor() {
        if (! instance) {
            instance = this;
            this.epoch = 0;
            this.timer = false;
            this.promises = [];
        }

        return instance;
    }

    init() {
        this.requestServerEpoch();
    }

    requestServerEpoch() {
        let urlSplit = document.location.toString();
        urlSplit = urlSplit.split('/');
        let host = urlSplit[2];
        let url = 'https://ofl-uk-clientside.api.ofl.uk/time';
        if (host === 'www.oakfurnitureland.co.uk' || host === 'www.oakfurnitureland.ie') {
            url = 'https://ofl-uk-clientside.api.ofl.uk/time';
        }
        
        $.get(url, (data, textStatus) => {
            if (textStatus === 'success') {
                let serverDate = parseInt(data);
                let currDate = new Date(serverDate);
                this.epoch = currDate.getTime()/1000;
                this.resolvePromises();
            }
        
            // Check the server time every minute.
            setTimeout(() => {
                this.requestServerEpoch();
            }, 60000);
        });
    }

    resolvePromises() {
        $.each(this.promises, (index, promise) => {
            promise.resolve('Server time updated');
        });
    }

    getEpoch() {
        return this.epoch;
    }

    successfulResponse() {
        let index = this.promises.length;
        this.promises[index] = $.Deferred();
        return this.promises[index].promise();
    }
}
